import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mhq_auth_token";

export const tokenStore = {
  get: () => {
    try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
  },
  set: (token) => {
    try { if (token) localStorage.setItem(TOKEN_KEY, token); } catch { /* ignore */ }
  },
  clear: () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
  },
};

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token (fallback for browsers that block 3rd-party cookies)
api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, drop the stale token so we re-auth cleanly
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      tokenStore.clear();
    }
    return Promise.reject(err);
  },
);

export default api;
